/**
 *  All api related to Favourites
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchFavourites(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchFavourites',
    () => source.cancel('fetchFavourites: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'favourites',
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      favourites: data.favourites,
      pagination: data.favouritesPagination,
      next: _.get(data, 'favouritesPagination.nextPage') > page
        ? () => fetchFavourites({ page: page + 1, ...others })
        : null,
      count: _.get(data, 'favouritesPagination.totalCount')
    }))
}

export function createFavourite(id, liked) {
  const data = {
    data: {
      favourite: {
        favourableType: 'ColorOption',
        favourableId: parseInt(id),
        liked
      }
    }
  }

  const source = CancelToken.source()
  cancelRequest.add(
    'createFavourite',
    () => source.cancel('createFavourite: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'favourites',
      method: 'post',
      data,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      favourite: data.favourite
    }))
}
